export default {
	title: "Lykkhjul",
	Lucky: "Lykkelig",
	wheels: "Hjul",
	winningrecord: "Vinnerrekord",
	ActivityRules: "Aktivitetsregler",
	ActivityRulesContent: "For mer informasjon om trekningen, vennligst kontakt kundeservice.",
	award: {
		title: "Gratulerer med gevinsten!",
		btn: "Motta premie"
	},
	noticeItem: "{0} har fått {1}",
	lotteryDraws: "{0} loddtrekninger",
	noAvailableTimes: "Utilstrekkelige tilgjengelige forsøk. Vennligst kontakt kundeservice.",
	noOpen: "Ikke åpnet ennå",
	noWinning: "Fortsett å prøve",
	ViewALlPrizes: "Se alle premier",
	myPrizes: "Mine premier",
	share: "Del med en venn"
};
